<template>
  <div class="wrapper">
    <div class="img_con">
      <img class="img1" src="../../assets/imgs/Artwork@2x.png" alt="" />
      <img class="img2" src="../../assets/imgs/pay-fail.png" alt="" />
    </div>
    <div class="text_con">
      <p class="text1">关联失败</p>
      <p class="text2">
        系统未检测到与您当前输入手机号匹配的账户信息，已为您创建新的账户。 请联系医生重新扫描医生二维码完成医生绑定。
      </p>
    </div>
    <div class="btn_con">
      <van-button color="#1E8DFF" @click="handleBack">返回</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkFail',
  data() {
    return {};
  },
  methods: {
    handleBack() {
      window.wx.closeWindow();
    }
  }
};
</script>

<style scoped lang="less">
.wrapper {
  height: 100%;
  background-color: #ffffff;
  .img_con {
    width: 228px;
    height: 228px;
    margin: auto;
    position: relative;
    top: 32px;
    .img1 {
      width: 100%;
      margin-top: 13.5px;
    }
    .img2 {
      width: 40px;
      position: absolute;
      right: 46px;
      bottom: 62px;
    }
  }
  .text_con {
    text-align: center;
    margin-top: 40px;
    .text1 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
    }
    .text2 {
      width: 204px;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      padding-top: 10px;
      margin: auto;
    }
  }
  .btn_con {
    text-align: center;
    margin-top: 28px;
    .van-button {
      width: 315px;
      height: 48px;
      line-height: 48px;
      color: #ffffff;
      font-size: 16px;
    }
  }
}
</style>
